export default "__VITE_ASSET__ASCAy5nM__"